var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/components/ui/styled/accordion.tsx
var accordion_exports = {};
__export(accordion_exports, {
  Context: () => AccordionContext,
  Item: () => Item,
  ItemContent: () => ItemContent,
  ItemContext: () => AccordionItemContext,
  ItemIndicator: () => ItemIndicator,
  ItemTrigger: () => ItemTrigger,
  Root: () => Root,
  RootProvider: () => RootProvider
});
import { Accordion } from "@ark-ui/solid";
import { accordion } from "styled-system/recipes";

// src/components/ui/styled/utils/create-style-context.tsx
import { createContext, useContext } from "solid-js";
import { Dynamic } from "solid-js/web";
import { cx } from "styled-system/css";
import { isCssProperty, styled } from "styled-system/jsx";
var shouldForwardProp = (prop, variantKeys, options = {}) => options.forwardProps?.includes(prop) || !variantKeys.includes(prop) && !isCssProperty(prop);
var createStyleContext = (recipe) => {
  const StyleContext = createContext(null);
  const withRootProvider6 = (Component) => {
    const StyledComponent = (props) => {
      const [variantProps, localProps] = recipe.splitVariantProps(props);
      const slotStyles = recipe(variantProps);
      return <StyleContext.Provider value={slotStyles}>
          <Component {...localProps} />
        </StyleContext.Provider>;
    };
    return StyledComponent;
  };
  const withProvider10 = (Component, slot, options) => {
    const StyledComponent = styled(
      Component,
      {},
      {
        shouldForwardProp: (prop, variantKeys) => shouldForwardProp(prop, variantKeys, options)
      }
    );
    return (props) => {
      const [variantProps, localProps] = recipe.splitVariantProps(props);
      const slotStyles = recipe(variantProps);
      return <StyleContext.Provider value={slotStyles}>
          <Dynamic
        component={StyledComponent}
        {...localProps}
        class={cx(slotStyles?.[slot], props.class)}
      />
        </StyleContext.Provider>;
    };
  };
  const withContext15 = (Component, slot) => {
    const StyledComponent = styled(Component);
    const Foo = (props) => {
      const slotStyles = useContext(StyleContext);
      return <Dynamic
        component={StyledComponent}
        {...props}
        class={cx(slotStyles?.[slot], props.class)}
      />;
    };
    return Foo;
  };
  return {
    withRootProvider: withRootProvider6,
    withProvider: withProvider10,
    withContext: withContext15
  };
};

// src/components/ui/styled/accordion.tsx
import { AccordionContext, AccordionItemContext } from "@ark-ui/solid";
var { withProvider, withContext } = createStyleContext(accordion);
var RootProvider = withProvider(Accordion.RootProvider, "root");
var Root = withProvider(Accordion.Root, "root");
var ItemContent = withContext(Accordion.ItemContent, "itemContent");
var ItemIndicator = withContext(Accordion.ItemIndicator, "itemIndicator");
var Item = withContext(
  Accordion.Item,
  "item"
);
var ItemTrigger = withContext(Accordion.ItemTrigger, "itemTrigger");

// src/components/ui/styled/alert.tsx
var alert_exports = {};
__export(alert_exports, {
  Content: () => Content,
  Description: () => Description,
  Icon: () => Icon,
  Root: () => Root2,
  Title: () => Title
});
import { ark } from "@ark-ui/solid";
import { alert } from "styled-system/recipes";
var { withProvider: withProvider2, withContext: withContext2 } = createStyleContext(alert);
var Root2 = withProvider2(
  ark.div,
  "root"
);
var Content = withContext2(
  ark.div,
  "content"
);
var Description = withContext2(
  ark.div,
  "description"
);
var Icon = withContext2(
  ark.svg,
  "icon"
);
var Title = withContext2(
  ark.h5,
  "title"
);

// src/components/ui/avatar.tsx
import { splitProps } from "solid-js";

// src/components/ui/styled/avatar.tsx
import { Avatar } from "@ark-ui/solid";
import { avatar } from "styled-system/recipes";
import { AvatarContext } from "@ark-ui/solid";
var { withProvider: withProvider3, withContext: withContext3 } = createStyleContext(avatar);
var RootProvider2 = withProvider3(Avatar.RootProvider, "root");
var Root3 = withProvider3(Avatar.Root, "root");
var Fallback = withContext3(
  Avatar.Fallback,
  "fallback"
);
var Image = withContext3(
  Avatar.Image,
  "image"
);

// src/components/ui/avatar.tsx
var Avatar2 = (props) => {
  const [localProps, rootProps] = splitProps(props, ["name", "src"]);
  return <Root3 {...rootProps}>
      <Fallback>{getInitials(localProps.name) || <UserIcon />}</Fallback>
      <Image src={localProps.src} alt={localProps.name} />
    </Root3>;
};
var UserIcon = () => <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
>
    <title>User Icon</title>
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>;
var getInitials = (name = "") => name.split(" ").map((part) => part[0]).splice(0, 2).join("").toUpperCase();

// src/components/ui/styled/badge.tsx
import { ark as ark2 } from "@ark-ui/solid";
import { styled as styled2 } from "styled-system/jsx";
import { badge } from "styled-system/recipes";
var Badge = styled2(ark2.div, badge);

// src/components/ui/button.tsx
import { Show, splitProps as splitProps3 } from "solid-js";
import { Center, styled as styled6 } from "styled-system/jsx";

// src/components/ui/spinner.tsx
import { mergeProps, splitProps as splitProps2 } from "solid-js";
import { styled as styled4 } from "styled-system/jsx";

// src/components/ui/styled/spinner.tsx
import { ark as ark3 } from "@ark-ui/solid";
import { styled as styled3 } from "styled-system/jsx";
import { spinner } from "styled-system/recipes";
var Spinner = styled3(ark3.div, spinner);

// src/components/ui/spinner.tsx
var Spinner2 = (props) => {
  const [_localProps, rootProps] = splitProps2(props, ["label"]);
  const localProps = mergeProps({ label: "Loading..." }, _localProps);
  return <Spinner borderBottomColor="transparent" borderLeftColor="transparent" {...rootProps}>
      <styled4.span srOnly>{localProps.label}</styled4.span>
    </Spinner>;
};

// src/components/ui/styled/button.tsx
import { ark as ark4 } from "@ark-ui/solid";
import { styled as styled5 } from "styled-system/jsx";
import { button } from "styled-system/recipes";
var Button = styled5(ark4.button, button);

// src/components/ui/button.tsx
var Button2 = (props) => {
  const [localProps, rest] = splitProps3(props, ["loading", "disabled", "loadingText", "children"]);
  const trulyDisabled = () => localProps.loading || localProps.disabled;
  return <Button disabled={trulyDisabled()} {...rest}>
      <Show
    when={localProps.loading && !localProps.loadingText}
    fallback={localProps.loadingText || localProps.children}
  >
        <>
          <ButtonSpinner />
          <styled6.span opacity={0}>{localProps.children}</styled6.span>
        </>
      </Show>
    </Button>;
};
var ButtonSpinner = () => <Center inline position="absolute" transform="translate(-50%, -50%)" top="50%" insetStart="50%">
    <Spinner2
  width="1.1em"
  height="1.1em"
  borderWidth="1.5px"
  borderTopColor="fg.disabled"
  borderRightColor="fg.disabled"
/>
  </Center>;

// src/components/ui/styled/card.tsx
var card_exports = {};
__export(card_exports, {
  Body: () => Body,
  Description: () => Description2,
  Footer: () => Footer,
  Header: () => Header,
  Root: () => Root4,
  Title: () => Title2
});
import { ark as ark5 } from "@ark-ui/solid";
import { card } from "styled-system/recipes";
var { withProvider: withProvider4, withContext: withContext4 } = createStyleContext(card);
var Root4 = withProvider4(
  ark5.div,
  "root"
);
var Body = withContext4(
  ark5.div,
  "body"
);
var Description2 = withContext4(
  ark5.div,
  "description"
);
var Footer = withContext4(
  ark5.div,
  "footer"
);
var Header = withContext4(
  ark5.div,
  "header"
);
var Title2 = withContext4(
  ark5.h3,
  "title"
);

// src/components/ui/styled/collapsible.tsx
var collapsible_exports = {};
__export(collapsible_exports, {
  Content: () => Content2,
  Context: () => CollapsibleContext,
  Root: () => Root5,
  RootProvider: () => RootProvider3,
  Trigger: () => Trigger
});
import { Collapsible } from "@ark-ui/solid";
import { collapsible } from "styled-system/recipes";
import { CollapsibleContext } from "@ark-ui/solid";
var { withProvider: withProvider5, withContext: withContext5 } = createStyleContext(collapsible);
var RootProvider3 = withProvider5(Collapsible.RootProvider, "root");
var Root5 = withProvider5(Collapsible.Root, "root");
var Content2 = withContext5(
  Collapsible.Content,
  "content"
);
var Trigger = withContext5(
  Collapsible.Trigger,
  "trigger"
);

// src/components/ui/styled/dialog.tsx
var dialog_exports = {};
__export(dialog_exports, {
  Backdrop: () => Backdrop,
  CloseTrigger: () => CloseTrigger,
  Content: () => Content3,
  Context: () => DialogContext,
  Description: () => Description3,
  Positioner: () => Positioner,
  Root: () => Root6,
  RootProvider: () => RootProvider4,
  Title: () => Title3,
  Trigger: () => Trigger2
});
import { Dialog } from "@ark-ui/solid";
import { dialog } from "styled-system/recipes";
import { DialogContext } from "@ark-ui/solid";
var { withRootProvider, withContext: withContext6 } = createStyleContext(dialog);
var RootProvider4 = withRootProvider(
  Dialog.RootProvider
);
var Root6 = withRootProvider(Dialog.Root);
var Backdrop = withContext6(
  Dialog.Backdrop,
  "backdrop"
);
var CloseTrigger = withContext6(Dialog.CloseTrigger, "closeTrigger");
var Content3 = withContext6(
  Dialog.Content,
  "content"
);
var Description3 = withContext6(
  Dialog.Description,
  "description"
);
var Positioner = withContext6(
  Dialog.Positioner,
  "positioner"
);
var Title3 = withContext6(
  Dialog.Title,
  "title"
);
var Trigger2 = withContext6(
  Dialog.Trigger,
  "trigger"
);

// src/components/ui/styled/drawer.tsx
var drawer_exports = {};
__export(drawer_exports, {
  Backdrop: () => Backdrop2,
  Body: () => Body2,
  CloseTrigger: () => CloseTrigger2,
  Content: () => Content4,
  Context: () => DialogContext2,
  Description: () => Description4,
  Footer: () => Footer2,
  Header: () => Header2,
  Positioner: () => Positioner2,
  Root: () => Root7,
  RootProvider: () => RootProvider5,
  Title: () => Title4,
  Trigger: () => Trigger3
});
import { Dialog as Dialog2, ark as ark6 } from "@ark-ui/solid";
import { drawer } from "styled-system/recipes";
import {
  DialogContext as DialogContext2
} from "@ark-ui/solid";
var { withRootProvider: withRootProvider2, withContext: withContext7 } = createStyleContext(drawer);
var RootProvider5 = withRootProvider2(Dialog2.RootProvider);
var Root7 = withRootProvider2(Dialog2.Root);
var Backdrop2 = withContext7(
  Dialog2.Backdrop,
  "backdrop"
);
var CloseTrigger2 = withContext7(Dialog2.CloseTrigger, "closeTrigger");
var Content4 = withContext7(
  Dialog2.Content,
  "content"
);
var Description4 = withContext7(
  Dialog2.Description,
  "description"
);
var Positioner2 = withContext7(
  Dialog2.Positioner,
  "positioner"
);
var Title4 = withContext7(
  Dialog2.Title,
  "title"
);
var Trigger3 = withContext7(
  Dialog2.Trigger,
  "trigger"
);
var Header2 = withContext7(
  ark6.div,
  "header"
);
var Body2 = withContext7(
  ark6.div,
  "body"
);
var Footer2 = withContext7(
  ark6.div,
  "footer"
);

// src/components/ui/styled/field.tsx
var field_exports = {};
__export(field_exports, {
  Context: () => FieldContext,
  ErrorText: () => ErrorText,
  HelperText: () => HelperText,
  Input: () => Input,
  Label: () => Label,
  Root: () => Root8,
  RootProvider: () => RootProvider6,
  Select: () => Select,
  Textarea: () => Textarea
});
import { Field } from "@ark-ui/solid";
import { styled as styled7 } from "styled-system/jsx";
import { field, input, textarea } from "styled-system/recipes";
import { FieldContext } from "@ark-ui/solid";
var { withProvider: withProvider6, withContext: withContext8 } = createStyleContext(field);
var RootProvider6 = withProvider6(Field.RootProvider, "root");
var Root8 = withProvider6(Field.Root, "root");
var ErrorText = withContext8(
  Field.ErrorText,
  "errorText"
);
var HelperText = withContext8(
  Field.HelperText,
  "helperText"
);
var Label = withContext8(
  Field.Label,
  "label"
);
var Select = withContext8(
  Field.Select,
  "select"
);
var Input = styled7(Field.Input, input);
var Textarea = styled7(Field.Textarea, textarea);

// src/components/ui/styled/file-upload.tsx
var file_upload_exports = {};
__export(file_upload_exports, {
  Context: () => FileUploadContext,
  Dropzone: () => Dropzone,
  HiddenInput: () => FileUploadHiddenInput,
  Item: () => Item2,
  ItemDeleteTrigger: () => ItemDeleteTrigger,
  ItemGroup: () => ItemGroup,
  ItemName: () => ItemName,
  ItemPreview: () => ItemPreview,
  ItemPreviewImage: () => ItemPreviewImage,
  ItemSizeText: () => ItemSizeText,
  Label: () => Label2,
  Root: () => Root9,
  RootProvider: () => RootProvider7,
  Trigger: () => Trigger4
});
import { FileUpload } from "@ark-ui/solid";
import { fileUpload } from "styled-system/recipes";
import {
  FileUploadContext,
  FileUploadHiddenInput
} from "@ark-ui/solid";
var { withProvider: withProvider7, withContext: withContext9 } = createStyleContext(fileUpload);
var RootProvider7 = withProvider7(FileUpload.RootProvider, "root");
var Root9 = withProvider7(FileUpload.Root, "root");
var Dropzone = withContext9(
  FileUpload.Dropzone,
  "dropzone"
);
var ItemDeleteTrigger = withContext9(FileUpload.ItemDeleteTrigger, "itemDeleteTrigger");
var ItemGroup = withContext9(
  FileUpload.ItemGroup,
  "itemGroup"
);
var ItemName = withContext9(
  FileUpload.ItemName,
  "itemName"
);
var ItemPreviewImage = withContext9(FileUpload.ItemPreviewImage, "itemPreviewImage");
var ItemPreview = withContext9(FileUpload.ItemPreview, "itemPreview");
var Item2 = withContext9(
  FileUpload.Item,
  "item"
);
var ItemSizeText = withContext9(FileUpload.ItemSizeText, "itemSizeText");
var Label2 = withContext9(
  FileUpload.Label,
  "label"
);
var Trigger4 = withContext9(
  FileUpload.Trigger,
  "trigger"
);

// src/components/ui/styled/form-label.tsx
import { ark as ark7 } from "@ark-ui/solid";
import { styled as styled8 } from "styled-system/jsx";
import { formLabel } from "styled-system/recipes";
var FormLabel = styled8(ark7.label, formLabel);

// src/components/ui/styled/heading.tsx
import { styled as styled9 } from "styled-system/jsx";
import { text } from "styled-system/recipes";
var Heading = styled9("h2", text, {
  defaultProps: { variant: "heading" }
});

// src/components/ui/styled/icon-button.tsx
import { ark as ark8 } from "@ark-ui/solid";
import { styled as styled10 } from "styled-system/jsx";
import { button as button2 } from "styled-system/recipes";
var IconButton = styled10(ark8.button, button2, {
  defaultProps: { px: "0" }
});

// src/components/ui/styled/menu.tsx
var menu_exports = {};
__export(menu_exports, {
  Arrow: () => Arrow,
  ArrowTip: () => ArrowTip,
  CheckboxItem: () => CheckboxItem,
  Content: () => Content5,
  Context: () => MenuContext,
  ContextTrigger: () => ContextTrigger,
  Indicator: () => Indicator,
  Item: () => Item3,
  ItemGroup: () => ItemGroup2,
  ItemGroupLabel: () => ItemGroupLabel,
  ItemIndicator: () => ItemIndicator2,
  ItemText: () => ItemText,
  Positioner: () => Positioner3,
  RadioItem: () => RadioItem,
  RadioItemGroup: () => RadioItemGroup,
  Root: () => Root10,
  RootProvider: () => RootProvider8,
  Separator: () => Separator,
  Trigger: () => Trigger5,
  TriggerItem: () => TriggerItem
});
import { Menu } from "@ark-ui/solid";
import { menu } from "styled-system/recipes";
import { MenuContext } from "@ark-ui/solid";
var { withRootProvider: withRootProvider3, withContext: withContext10 } = createStyleContext(menu);
var RootProvider8 = withRootProvider3(
  Menu.RootProvider
);
var Root10 = withRootProvider3(Menu.Root);
var Arrow = withContext10(
  Menu.Arrow,
  "arrow"
);
var ArrowTip = withContext10(
  Menu.ArrowTip,
  "arrowTip"
);
var CheckboxItem = withContext10(
  Menu.CheckboxItem,
  "item"
);
var Content5 = withContext10(
  Menu.Content,
  "content"
);
var ContextTrigger = withContext10(Menu.ContextTrigger, "contextTrigger");
var Indicator = withContext10(
  Menu.Indicator,
  "indicator"
);
var ItemGroupLabel = withContext10(Menu.ItemGroupLabel, "itemGroupLabel");
var ItemGroup2 = withContext10(
  Menu.ItemGroup,
  "itemGroup"
);
var ItemIndicator2 = withContext10(Menu.ItemIndicator, "itemIndicator");
var Item3 = withContext10(
  Menu.Item,
  "item"
);
var ItemText = withContext10(
  Menu.ItemText,
  "itemText"
);
var Positioner3 = withContext10(
  Menu.Positioner,
  "positioner"
);
var RadioItemGroup = withContext10(Menu.RadioItemGroup, "itemGroup");
var RadioItem = withContext10(
  Menu.RadioItem,
  "item"
);
var Separator = withContext10(
  Menu.Separator,
  "separator"
);
var TriggerItem = withContext10(
  Menu.TriggerItem,
  "triggerItem"
);
var Trigger5 = withContext10(
  Menu.Trigger,
  "trigger"
);

// src/components/ui/styled/popover.tsx
var popover_exports = {};
__export(popover_exports, {
  Anchor: () => Anchor,
  Arrow: () => Arrow2,
  ArrowTip: () => ArrowTip2,
  CloseTrigger: () => CloseTrigger3,
  Content: () => Content6,
  Context: () => PopoverContext,
  Description: () => Description5,
  Indicator: () => Indicator2,
  Positioner: () => Positioner4,
  Root: () => Root11,
  RootProvider: () => RootProvider9,
  Title: () => Title5,
  Trigger: () => Trigger6
});
import { Popover } from "@ark-ui/solid";
import { popover } from "styled-system/recipes";
import { PopoverContext } from "@ark-ui/solid";
var { withRootProvider: withRootProvider4, withContext: withContext11 } = createStyleContext(popover);
var RootProvider9 = withRootProvider4(Popover.RootProvider);
var Root11 = withRootProvider4(Popover.Root);
var Anchor = withContext11(
  Popover.Anchor,
  "anchor"
);
var Arrow2 = withContext11(
  Popover.Arrow,
  "arrow"
);
var ArrowTip2 = withContext11(
  Popover.ArrowTip,
  "arrowTip"
);
var CloseTrigger3 = withContext11(Popover.CloseTrigger, "closeTrigger");
var Content6 = withContext11(
  Popover.Content,
  "content"
);
var Description5 = withContext11(Popover.Description, "description");
var Indicator2 = withContext11(
  Popover.Indicator,
  "indicator"
);
var Positioner4 = withContext11(
  Popover.Positioner,
  "positioner"
);
var Title5 = withContext11(
  Popover.Title,
  "title"
);
var Trigger6 = withContext11(
  Popover.Trigger,
  "trigger"
);

// src/components/ui/progress.tsx
import { Show as Show2, children, splitProps as splitProps4 } from "solid-js";

// src/components/ui/styled/progress.tsx
import { Progress } from "@ark-ui/solid";
import { progress } from "styled-system/recipes";
import { ProgressContext } from "@ark-ui/solid";
var { withProvider: withProvider8, withContext: withContext12 } = createStyleContext(progress);
var RootProvider10 = withProvider8(Progress.RootProvider, "root");
var Root12 = withProvider8(Progress.Root, "root");
var Circle = withContext12(
  Progress.Circle,
  "circle"
);
var CircleRange = withContext12(Progress.CircleRange, "circleRange");
var CircleTrack = withContext12(Progress.CircleTrack, "circleTrack");
var Label3 = withContext12(
  Progress.Label,
  "label"
);
var Range = withContext12(
  Progress.Range,
  "range"
);
var Track = withContext12(
  Progress.Track,
  "track"
);
var ValueText = withContext12(
  Progress.ValueText,
  "valueText"
);
var View = withContext12(
  Progress.View,
  "view"
);

// src/components/ui/progress.tsx
var Progress2 = (props) => {
  const [localProps, rootProps] = splitProps4(props, ["children", "type"]);
  const getChildren = children(() => localProps.children);
  return <Root12 {...rootProps}>
      <Show2 when={getChildren()}>
        <Label3>{getChildren()}</Label3>
      </Show2>
      <Show2
    when={localProps.type === "circular"}
    fallback={<Track>
            <Range />
          </Track>}
  >
        <Circle>
          <CircleTrack />
          <CircleRange />
          <ValueText />
        </Circle>
      </Show2>
      <ValueText />
    </Root12>;
};

// src/components/ui/select.tsx
import { createListCollection } from "@ark-ui/solid/select";

// src/components/ui/styled/select.tsx
var select_exports = {};
__export(select_exports, {
  ClearTrigger: () => ClearTrigger,
  Content: () => Content7,
  Context: () => SelectContext,
  Control: () => Control,
  HiddenSelect: () => SelectHiddenSelect,
  Indicator: () => Indicator3,
  Item: () => Item4,
  ItemGroup: () => ItemGroup3,
  ItemGroupLabel: () => ItemGroupLabel2,
  ItemIndicator: () => ItemIndicator3,
  ItemText: () => ItemText2,
  Label: () => Label4,
  List: () => List,
  Positioner: () => Positioner5,
  Root: () => Root13,
  RootProvider: () => RootProvider11,
  Trigger: () => Trigger7,
  ValueText: () => ValueText2
});
import { Select as Select2 } from "@ark-ui/solid";
import { select } from "styled-system/recipes";
import {
  SelectContext,
  SelectHiddenSelect
} from "@ark-ui/solid";
var { withRootProvider: withRootProvider5, withContext: withContext13 } = createStyleContext(select);
var RootProvider11 = withRootProvider5(Select2.RootProvider);
var Root13 = withRootProvider5(Select2.Root);
var ClearTrigger = withContext13(Select2.ClearTrigger, "clearTrigger");
var Content7 = withContext13(
  Select2.Content,
  "content"
);
var Control = withContext13(
  Select2.Control,
  "control"
);
var Indicator3 = withContext13(
  Select2.Indicator,
  "indicator"
);
var ItemGroupLabel2 = withContext13(Select2.ItemGroupLabel, "itemGroupLabel");
var ItemGroup3 = withContext13(
  Select2.ItemGroup,
  "itemGroup"
);
var ItemIndicator3 = withContext13(Select2.ItemIndicator, "itemIndicator");
var Item4 = withContext13(
  Select2.Item,
  "item"
);
var ItemText2 = withContext13(
  Select2.ItemText,
  "itemText"
);
var Label4 = withContext13(
  Select2.Label,
  "label"
);
var List = withContext13(
  Select2.List,
  "list"
);
var Positioner5 = withContext13(
  Select2.Positioner,
  "positioner"
);
var Trigger7 = withContext13(
  Select2.Trigger,
  "trigger"
);
var ValueText2 = withContext13(
  Select2.ValueText,
  "valueText"
);

// src/components/ui/styled/table.tsx
var table_exports = {};
__export(table_exports, {
  Body: () => Body3,
  Caption: () => Caption,
  Cell: () => Cell,
  Foot: () => Foot,
  Head: () => Head,
  Header: () => Header3,
  Root: () => Root14,
  Row: () => Row
});
import { ark as ark9 } from "@ark-ui/solid";
import { table } from "styled-system/recipes";
var { withProvider: withProvider9, withContext: withContext14 } = createStyleContext(table);
var Root14 = withProvider9(
  ark9.table,
  "root"
);
var Body3 = withContext14(
  ark9.tbody,
  "body"
);
var Caption = withContext14(
  ark9.caption,
  "caption"
);
var Cell = withContext14(
  ark9.td,
  "cell"
);
var Foot = withContext14(
  ark9.tfoot,
  "footer"
);
var Head = withContext14(
  ark9.thead,
  "head"
);
var Header3 = withContext14(
  ark9.th,
  "header"
);
var Row = withContext14(ark9.tr, "row");

// src/components/ui/styled/text.tsx
import { styled as styled11 } from "styled-system/jsx";
import { text as text2 } from "styled-system/recipes";
var Text = styled11("p", text2);

// ../../node_modules/.pnpm/lucide-solid@0.465.0_solid-js@1.9.7/node_modules/lucide-solid/dist/esm/Icon.js
import { spread, mergeProps as mergeProps2, memo, insert, createComponent, Dynamic as Dynamic2, template } from "solid-js/web";
import { splitProps as splitProps5, For } from "solid-js";

// ../../node_modules/.pnpm/lucide-solid@0.465.0_solid-js@1.9.7/node_modules/lucide-solid/dist/esm/defaultAttributes.js
var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};

// ../../node_modules/.pnpm/lucide-solid@0.465.0_solid-js@1.9.7/node_modules/lucide-solid/dist/esm/shared/src/utils.js
var toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
var mergeClasses = (...classes) => classes.filter((className, index, array) => {
  return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
}).join(" ").trim();

// ../../node_modules/.pnpm/lucide-solid@0.465.0_solid-js@1.9.7/node_modules/lucide-solid/dist/esm/Icon.js
var _tmpl$ = /* @__PURE__ */ template(`<svg>`);
var Icon2 = (props) => {
  const [localProps, rest] = splitProps5(props, ["color", "size", "strokeWidth", "children", "class", "name", "iconNode", "absoluteStrokeWidth"]);
  return (() => {
    var _el$ = _tmpl$();
    spread(_el$, mergeProps2(defaultAttributes, {
      get width() {
        return localProps.size ?? defaultAttributes.width;
      },
      get height() {
        return localProps.size ?? defaultAttributes.height;
      },
      get stroke() {
        return localProps.color ?? defaultAttributes.stroke;
      },
      get ["stroke-width"]() {
        return memo(() => !!localProps.absoluteStrokeWidth)() ? Number(localProps.strokeWidth ?? defaultAttributes["stroke-width"]) * 24 / Number(localProps.size) : Number(localProps.strokeWidth ?? defaultAttributes["stroke-width"]);
      },
      get ["class"]() {
        return mergeClasses("lucide", "lucide-icon", localProps.name != null ? `lucide-${toKebabCase(localProps?.name)}` : void 0, localProps.class != null ? localProps.class : "");
      }
    }, rest), true, true);
    insert(_el$, createComponent(For, {
      get each() {
        return localProps.iconNode;
      },
      children: ([elementName, attrs]) => {
        return createComponent(Dynamic2, mergeProps2({
          component: elementName
        }, attrs));
      }
    }));
    return _el$;
  })();
};

// ../../node_modules/.pnpm/lucide-solid@0.465.0_solid-js@1.9.7/node_modules/lucide-solid/dist/esm/icons/check.js
import { createComponent as createComponent2, mergeProps as mergeProps3 } from "solid-js/web";
var iconNode = [["path", {
  d: "M20 6 9 17l-5-5",
  key: "1gmf2c"
}]];
var Check = (props) => createComponent2(Icon2, mergeProps3(props, {
  name: "Check",
  iconNode
}));

// ../../node_modules/.pnpm/lucide-solid@0.465.0_solid-js@1.9.7/node_modules/lucide-solid/dist/esm/icons/chevron-down.js
import { createComponent as createComponent3, mergeProps as mergeProps4 } from "solid-js/web";
var iconNode2 = [["path", {
  d: "m6 9 6 6 6-6",
  key: "qrunsl"
}]];
var ChevronDown = (props) => createComponent3(Icon2, mergeProps4(props, {
  name: "ChevronDown",
  iconNode: iconNode2
}));

// ../../node_modules/.pnpm/lucide-solid@0.465.0_solid-js@1.9.7/node_modules/lucide-solid/dist/esm/icons/x.js
import { createComponent as createComponent4, mergeProps as mergeProps5 } from "solid-js/web";
var iconNode3 = [["path", {
  d: "M18 6 6 18",
  key: "1bl5f8"
}], ["path", {
  d: "m6 6 12 12",
  key: "d8bk6v"
}]];
var X = (props) => createComponent4(Icon2, mergeProps5(props, {
  name: "X",
  iconNode: iconNode3
}));

// src/custom/AppDrawer.tsx
import { css } from "styled-system/css";
var AppDrawer = (props) => {
  return <drawer_exports.Root {...props}>
			<drawer_exports.Trigger>{props.trigger}</drawer_exports.Trigger>
			<drawer_exports.Backdrop />
			<drawer_exports.Positioner>
				<drawer_exports.Content>
					<drawer_exports.Header>
						<div
    class={css({
      display: "grid",
      gridTemplateColumns: "1fr auto",
      justifyContent: "space-between",
      alignItems: "center"
    })}
  >
							<drawer_exports.Title>{props.title}</drawer_exports.Title>
							<drawer_exports.CloseTrigger
    asChild={(closeProps) => <IconButton
      variant="subtle"
      colorPalette="accent"
      {...closeProps}
    >
										<X />
									</IconButton>}
  />
						</div>
					</drawer_exports.Header>
					<drawer_exports.Body>{props.children}</drawer_exports.Body>
				</drawer_exports.Content>
			</drawer_exports.Positioner>
		</drawer_exports.Root>;
};

// src/custom/SelectField.tsx
var SelectField = (props) => {
  const collection = createListCollection({ items: props.items });
  const handleChange = (e) => {
    props.onChange(e.value);
  };
  return <select_exports.Root
    onValueChange={handleChange}
    name={props.name}
    value={props.value}
    positioning={{ sameWidth: true }}
    width="2xs"
    collection={collection}
  >
			<select_exports.Label>{props.label}</select_exports.Label>
			<select_exports.Control>
				<select_exports.Trigger>
					<select_exports.ValueText
    placeholder={props.placeholder}
    asChild={(props2) => <Text {...props2} />}
  />
					<ChevronDown />
				</select_exports.Trigger>
			</select_exports.Control>
			<select_exports.Positioner>
				<select_exports.Content>
					<select_exports.ItemGroup>
						{props.items.map((item) => <select_exports.Item item={item}>
								<select_exports.ItemText>{item.label}</select_exports.ItemText>
								<select_exports.ItemIndicator>
									<Check />
								</select_exports.ItemIndicator>
							</select_exports.Item>)}
					</select_exports.ItemGroup>
				</select_exports.Content>
			</select_exports.Positioner>
		</select_exports.Root>;
};

// src/custom/Paper.tsx
import { css as css2, cx as cx2 } from "styled-system/css";
var Paper = (props) => {
  const { noBorder, noPadding, children: children2, ...rest } = props;
  return <div
    class={cx2(
      props.class,
      css2({
        boxShadow: "none",
        borderRadius: "l2",
        p: noPadding ? 0 : 3,
        border: noBorder ? "none" : "solid 1px var(--colors-gray-4)"
      })
    )}
  >
			{props.children}
		</div>;
};

// src/custom/DirectionBadge.tsx
var PositionBadge = (props) => {
  const isLong = props.position.toLowerCase() === "long";
  return <Badge
    {...props}
    background={isLong ? "tscGreen.a5" : "red.a5"}
  >
			{props.position?.toUpperCase()}
		</Badge>;
};
export {
  accordion_exports as Accordion,
  alert_exports as Alert,
  AppDrawer,
  Avatar2 as Avatar,
  Badge,
  Button2 as Button,
  card_exports as Card,
  collapsible_exports as Collapsible,
  dialog_exports as Dialog,
  drawer_exports as Drawer,
  field_exports as Field,
  file_upload_exports as FileUpload,
  FormLabel,
  Heading,
  IconButton,
  menu_exports as Menu,
  Paper,
  popover_exports as Popover,
  PositionBadge,
  Progress2 as Progress,
  select_exports as Select,
  SelectField,
  Spinner2 as Spinner,
  table_exports as Table,
  Text,
  createListCollection
};
/*! Bundled license information:

lucide-solid/dist/esm/defaultAttributes.js:
lucide-solid/dist/esm/shared/src/utils.js:
lucide-solid/dist/esm/Icon.js:
lucide-solid/dist/esm/icons/check.js:
lucide-solid/dist/esm/icons/chevron-down.js:
lucide-solid/dist/esm/icons/x.js:
lucide-solid/dist/esm/lucide-solid.js:
  (**
   * @license lucide-solid v0.465.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)
*/
